import Vue from 'vue'

/**
 * 深拷贝对象
 * 解决Object.assign(target, source)问题：如果source属性值为对象或其它引用类型，那对于这个对象而言其实是浅拷贝的
 * @param {*} source 
 */
 export function clone(source) {
    return JSON.parse(JSON.stringify(source));
}

export function fromArray(array, keyFunction) {
    let map = {};
    array.forEach(i => map[keyFunction(i)] = i);
    return map;
}

Vue.prototype.$clone = clone